import router from './router'
import store from './store/index'
router.beforeEach((to, from, next) => {
    //console.log(to.path)
    if (to.path === '/index' || to.path == '/') {
        next()
    }else{
        let id = to.path.split('/')[1]
    store.commit('SET_ID',id)
        next({ path: '' })
    }
})